import React from 'react';
import { useParams } from 'react-router';
import { Grid } from '@mui/material';
import MemberLayout from '../../../components/layouts/MemberLayout';
import MemberProfileAvatar from '../../../components/member/aboutme/MemberProfileAvatar';
import LeaderboardDetails from '../../../components/member/contest/LeaderboardDetails';

type Params = {
  contestId: string;
  rollup: string;
};

const MemberLeaderboard: React.FC = () => {
  const { contestId, rollup } = useParams<Params>();

  return (
    <MemberLayout>
      <Grid container spacing={6} justifyContent="center">
        <Grid item xs={12}>
          <MemberProfileAvatar />
        </Grid>
        <Grid item xs={12}>
          <LeaderboardDetails contestId={contestId} rollup={rollup} />
        </Grid>
      </Grid>
    </MemberLayout>
  );
};

export default MemberLeaderboard;
